<template>
  <div class="container-fluid ">
    <Heard />
    <div class="indebox mt-15">
      <!-- <img class="container-fluid" src="@/assets/image/indexcont.png" alt="" /> -->
      <div class="each-model">
        <div class="title">
          <div class="maintitle">
            <div class="hightlight-blue" style="margin-right: 20px;">
              掌心职学
              <img class="star_01" src="@/assets/home/-h-star_01.png">
            </div>
            <span>让招聘更简单</span>
          </div>
          <div class="subtitle">
            让技术人性化，让招聘智能化，HR更爱用的智能化招聘管理系统
          </div>
        </div>
        <div class="free-for-use cursor-pointer" @click="handBtn">
          免费试用
        </div>
        <div class="group">

        </div>
      </div>
      <div class="each-model">
        <div class="title">
          <div class="maintitle">
            <div class="hightlight-blue">
              核心功能
              <img class="star_02" src="@/assets/home/-h-star_01.png">
            </div>
            <span>让招聘更简单</span>
          </div>
          <div class="subtitle">
            让技术人性化，让招聘智能化，HR更爱用的智能化招聘管理系统
          </div>
        </div>
        <div class="group2">
          <div class="promo">
            <div class="promo_title">AI面试</div>
            <div class="desc">基于深度学习的 GAN 模型，在文本、语音、图像等方面，实现高效的多模态融合与转换。</div>
            <el-button round style="color: #006FD5;" @click="handBtn">免费试用</el-button>
          </div>
          <div class="promo">
            <div class="promo_title">全职位人才库</div>
            <div class="desc">基于深度学习的 GAN 模型，在文本、语音、图像等方面，实现高效的多模态融合与转换。</div>
            <el-button round style="color: #219764;" @click="handBtn">免费试用</el-button>
          </div>
          <div class="promo">
            <div class="promo_title">人岗匹配指数</div>
            <div class="desc">基于深度学习的 GAN 模型，在文本、语音、图像等方面，实现高效的多模态融合与转换。</div>
            <el-button round style="color: #5250DA;" @click="handBtn"> 免费试用</el-button>
          </div>
        </div>
      </div>
      <div class="each-model flex">
        <div class="title">
          <div class="maintitle">
            <div class="hightlight-blue ">
              合作企业
              <!-- <img class="star_02" src="@/assets/home/-h-star_01.png"> -->
            </div>
            <span>让招聘更简单</span>
          </div>
          <div class="subtitle">
            让技术人性化，让招聘智能化，HR更爱用的智能化招聘管理系统
          </div>
        </div>
        <div class="flex" :style="{ 'width': screenWidth + 10 + 'px' }">
          <vue-seamless-scroll :data="listData" :class-option="classOption" class="warp ">
            <ul class="ul-item ">
              <li class="li-item " v-for="(item, index) in listData" :key="index">

                <div class="bg-[#fff]">
                  <img class="w-510  mb-10  rounded-[20px]" :src="item.src">
                </div>

              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="flex mt-20" :style="{ 'width': screenWidth + 10 + 'px' }">
          <vue-seamless-scroll :data="listData2" :class-option="classOption" class="warp ">
            <ul class="ul-item ">
              <li class="li-item " v-for="(item, index) in listData2" :key="index">

                <img class="w-510  mb-10 bg-[#fff] " :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="flex mt-20" :style="{ 'width': screenWidth + 10 + 'px' }">
          <vue-seamless-scroll :data="listData3" :class-option="classOption" class="warp ">
            <ul class="ul-item ">
              <li class="li-item " v-for="(item, index) in listData3" :key="index">

                <img class="w-510  mb-10  bg-[#fff]" :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="flex mt-20" :style="{ 'width': screenWidth + 10 + 'px' }">
          <vue-seamless-scroll :data="listData4" :class-option="classOption" class="warp ">
            <ul class="ul-item ">
              <li class="li-item " v-for="(item, index) in listData4" :key="index">

                <img class="w-510  mb-10  bg-[#fff]" :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="flex mt-20" :style="{ 'width': screenWidth + 10 + 'px' }">
          <vue-seamless-scroll :data="listData5" :class-option="classOption" class="warp ">
            <ul class="ul-item ">
              <li class="li-item " v-for="(item, index) in listData5" :key="index">

                <img class="w-510  mb-10  bg-[#fff]" :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
      <div class="each-model mb-30">
        <div class="title">
          <div class="maintitle">
            <div class="hightlight-blue" style="margin-right: 20px;">
              用户心声
              <img class="star_01" src="@/assets/home/-h-heart_01.png">
            </div>
            <span>让招聘更简单</span>
          </div>
          <div class="subtitle">
            让技术人性化，让招聘智能化，HR更爱用的智能化招聘管理系统
          </div>
        </div>
        <div class="group4">
          <div class="promo">
            <div class="promo_avatar">
              <img class="avatar" src="@/assets/home/dcfc62ec1936e9d630e7a4d1919390a.png">
              <div class="info">
                <div class="name">覃先生</div>
                <div class="postname">企业招聘主管</div>
              </div>
            </div>
            <div class="content">
              智能化招聘，未来已来！<br>掌心职学的智能化招聘管理系统让我感受到了科技的力量。AI面试不仅让招聘过程更加智能化，还提升了我们的a招聘质量。现在，我们不再为繁琐的面试安排和筛选工作而烦恼，可以更加专注于候选人的能力和潜力。感谢掌心职学，让我们HR的工作更加轻松和高效。
            </div>
            <div class="desc">
              <div class="icon flex items-center">
                <img src="@/assets/home/-h-icon_correct.png" class=" mr-4">
                <div>智能化招聘，未来已来！</div>
              </div>
              <!-- <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
               <div>节约招聘成本</div> 
              </div>
              <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
                <div>数字化流程</div> 
              </div> -->
            </div>
          </div>
          <div class="promo">
            <div class="promo_avatar">
              <img class="avatar" src="@/assets/home/20460db5f6af3b3da86da572f3b7a4a.png">
              <div class="info">
                <div class="name">王女士</div>
                <div class="postname">企业招聘主管</div>
              </div>
            </div>
            <div class="content">AI面试，让招聘更高效！<br>
              自从使用了智面的AI面试功能，我们的招聘流程变得更加高效和便捷。AI能够迅速筛选出合适的候选人，大大减轻了HR的工作负担。同时，AI面试的标准化和客观性也提高了招聘的公正性和准确性。
              真心推荐其他HR朋友们试试！</div>
            <div class="desc">
              <div class="icon flex items-center">
                <img src="@/assets/home/-h-icon_correct.png" class=" mr-4">
                <div>AI面试，让招聘更高效！</div>
              </div>
              <!-- <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
               <div>节约招聘成本</div> 
              </div>
              <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
                <div>数字化流程</div> 
              </div> -->
            </div>
          </div>
          <div class="promo">
            <div class="promo_avatar">
              <img class="avatar" src="@/assets/home/e5483c1880d62a66169aad23534b266.png">
              <div class="info">
                <div class="name">方女士</div>
                <div class="postname">企业招聘主管</div>
              </div>
            </div>
            <div class="content">AI智能面试
              提供高效招聘流程

              全方位保障
              确保招聘质量、降低潜在风险

              高效的招聘
              招聘流程变得更加高效和便捷

              人才库
              精准匹配，快速找到合适的人选。</div>
            <div class="desc">
              <div class="icon flex items-center">
                <img src="@/assets/home/-h-icon_correct.png" class=" mr-4">
                <div>AI助力，招聘更轻松！</div>
              </div>
              <!-- <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
               <div>节约招聘成本</div> 
              </div>
              <div class="icon  flex items-center">
                <img src="@/assets/home/-h-icon_correct.png">
                <div>数字化流程</div> 
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="comtitle container">讲师介绍</div> -->

    <!-- <div class="tec-box container">
      <el-carousel trigger="click" height="440px" :interval="5000">
        <el-carousel-item v-for="item in teclist" :key="item.id">
          <img :src="item.src1" alt="" />
          <img :src="item.src2" alt="" />
          <img :src="item.src3" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="container-fluid bgcfoot ">
      <div class="footbox" >一键开启轻松招聘</div>
      <div class="input">
        <el-input placeholder="输入您的电话" v-model="mobile" >
          <template slot="append" >
            <div @click="getList">产品咨询</div>
          </template>
        </el-input>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>

import vueSeamlessScroll from 'vue-seamless-scroll'
// import { addAdviceInfo } from "@/apis/apis";
import axios from 'axios';
import Heard from "@/components/Heard.vue";
import Footer from "@/components/Footer.vue";
import img1 from "@/assets/tab-1/1(1).png";
import img2 from "@/assets/tab-1/1(2).png";
import img3 from "@/assets/tab-1/1(3).png";
import img4 from "@/assets/tab-1/1(4).png";
import img5 from "@/assets/tab-1/1(5).png";
import img6 from "@/assets/tab-1/1(6).png";
import img7 from "@/assets/tab-1/1(7).png";
import img8 from "@/assets/tab-1/1(8).png";
import img9 from "@/assets/tab-1/1(9).png";
import img10 from "@/assets/tab-1/1(10).png";
import img11 from "@/assets/tab-1/1(11).png";
import img12 from "@/assets/tab-1/1(12).png";
import img13 from "@/assets/tab-1/1(13).png";
import img14 from "@/assets/tab-1/1(14).png";
import img15 from "@/assets/tab-1/1(15).png";
import img16 from "@/assets/tab-1/1(16).png";


export default {
  components: {
    Heard,
    Footer,
    vueSeamlessScroll
  },
   metaInfo() {
    return {
      meta: [
        { name: 'keywords', content: this.$route.meta.keywords },
        { name: 'description', content: this.$route.meta.description }
      ]
    };
  },
  // layouts: "index",
  data() {
    return {
      mobile:'',
      screenWidth: document.body.clientWidth,

      classOption: {
        limitMoveNum: 1,
        direction: 2,
      },

      listData: [

        { src: img1 },
        { src: img2 },
        { src: img3 },
        { src: img4 },
        { src: img11 },
        { src: img12 },


      ],
      listData2: [

        { src: img5 },
        { src: img6 },
        { src: img7 },
        { src: img8 },
        { src: img3 },
        { src: img4 },


      ],
      listData3: [

        { src: img9 },
        { src: img10 },
        { src: img11 },
        { src: img12 },
        { src: img5 },
        { src: img6 },


      ],
      listData4: [

        { src: img13 },
        { src: img14 },
        { src: img15 },
        { src: img16 },
        { src: img9 },
        { src: img10 },


      ],
      listData5: [

        { src: img1 },
        { src: img2 },
        { src: img3 },
        { src: img4 },
        { src: img13 },
        { src: img14 },


      ],


    };
  },

  // 监听属性 类似于data概念
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }

  },
  async created() {
    // this.toSrcollLeft()


  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      // 更新窗口宽度
      this.screenWidth = document.body.clientWidth;
    });

  },
  methods: {    //乱七八糟，写的啥东西啊，不需要的不会删嘛。恶心人是吧，我也不删

    // 产品咨询
    handBtn() {
      window.open('http://web.manager.b.hrclass.com.cn/')
    },



    getList() {
      if(this.mobile == '' || this.mobile.length != 11 ){
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
        return
      }else{
        axios({
        method: "post",
        data:{mobile:this.mobile},
        url: "https://aid.hrclass.com.cn/web/services/addAdviceInfo"
      }).then(res => {
        console.log(res);
        
       if(res.data.code == '200'){
        this.$message({
          message: '提交成功',
          type: 'success'
        });
       }
       this.mobile = ''
      })
      }
   
    }
  








},

};
</script>

<style lang="less" scoped>
.warp {
  width: 256px*8;
  height: 84px;
  margin: 0 auto;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;

      .li-item {
        width: 256px;
        height: 84px;
        margin-right: 30px;

        line-height: 120px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.scroll-item {
  display: inline-block;
  /* 使每个项横向排列 */
  width: 200px;
  /* 每个项的宽度 */
  text-align: center;
  /* 使文本居中 */
}

.indebox {
  .each-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .title {
      margin-top: 80px;

      .maintitle {
        display: flex;
        font-size: 44px;
        font-weight: bold;
        width: fit-content;
        margin: 0 auto;
        color: #444444;

        .hightlight-blue {
          color: #2E77FE;
          position: relative;

          .star_01 {
            position: absolute;
            top: -10px;
            right: -26px;
            width: 30px;
          }

          .star_02 {
            position: absolute;
            top: 0px;
            left: -28px;
            width: 30px;
          }
        }
      }

      .subtitle {
        font-size: 24px;
        color: #444444;
        line-height: 49px;
      }
    }

    .free-for-use {
      width: 130px;
      height: 44px;
      line-height: 44px;
      background: #2E77FE;
      border-radius: 22px;
      color: #fff;
      text-align: center;
      margin-top: 25px;
    }

    .group {
      background: url(~@/assets/home/group.png) no-repeat;
      background-size: 100% 100%;
      width: 1268px;
      height: 608px;
      // box-shadow: 0px 6px 24px 0px #C0D4E3;
      border-radius: 24px;
      position: absolute;
      bottom: -120px;
      z-index: 1;
    }

    .group2 {
      display: flex;
      justify-content: space-between;

      .promo {
        width: 370px;
        height: 450px;
        font-weight: bold;
        font-size: 30px;
        padding: 50px 60px;
        margin-top: 40px;

        .promo_title {
          margin-bottom: 20px;
        }

        .desc {
          font-size: 18px;
          font-weight: normal;
          line-height: 24px;
          margin-bottom: 20px;
        }

        &:nth-child(1) {
          background: url(~@/assets/home/-h-promo_1.png) no-repeat;
          background-size: 100% 100%;
          color: #006FD5;
        }

        &:nth-child(2) {
          background: url(~@/assets/home/-h-promo_2.png) no-repeat;
          background-size: 100% 100%;
          color: #219764;
        }

        &:nth-child(3) {
          background: url(~@/assets/home/-h-promo_3.png) no-repeat;
          background-size: 100% 100%;
          color: #5250DA;
        }
      }
    }

    .group3 {
      width: 800px;
      /* 或者设置为具体宽度 */
      overflow: hidden;
      white-space: nowrap;
      /* 防止换行 */
      border: #006FD5 solid 1px;
      overflow: hidden;
      margin: 60px auto 0;




    }

    .group4 {
      width: 1100px;
      display: flex;
      justify-content: space-between;

      .promo {
        width: 354px;
        height: 340px;
        padding: 50px 30px 30px 30px;
        margin-top: 55px;
        background: url(~@/assets/home/-h-whoissay_bg.png) no-repeat;
        background-size: 100% 100%;
        position: relative;

        .promo_avatar {
          display: flex;
          align-items: center;

          .avatar {
            width: 49px;
            margin-right: 8px;
          }

          .info {
            .name {
              font-weight: 600;
              font-size: 16px;
              color: #222222;
              line-height: 24px;
            }

            .postname {
              font-size: 14px;
              color: #666666;
            }
          }
        }

        .content {
          margin: 30px auto 0;
          width: 290px;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
        }

        .desc {
          position: absolute;
          bottom: 16px;
          display: flex;
          font-size: 13px;
          color: #666666;

          .icon {
            margin-right: 14px;

            img {
              width: 15px;
            }
          }
        }
      }
    }

    &:nth-child(1) {
      height: 730px;
      background: url(~@/assets/home/-h-channel_bg_01.jpg) no-repeat;
      background-size: 100% 100%;
    }

    &:nth-child(2) {
      height: 820px;
      background: url(~@/assets/home/-h-channel_bg_02.jpg) no-repeat;
      background-size: 100% 100%;

      .title {
        margin-top: 180px;
      }
    }

    &:nth-child(3) {
      height: 740px;
      background: url(~@/assets/home/-h-channel_bg_03.jpg) no-repeat;
      background-size: 100% 100%;
    }

    &:nth-child(4) {
      height: 560px;
      background: url(~@/assets/home/-h-channel_bg_04.jpg) no-repeat;
      background-size: 100% 100%;
    }
  }
}

.bgcfoot {
  height: 240px;
  background: url(~@/assets/home/-h-channel_bg_05.jpg) no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;

  .footbox {
    width: 317px;
    font-family: HONOR Sans CN;
    font-size: 34px;
    color: #2E77FE;
    margin: 60px auto 37px;
  }

  .input {
    margin: 0 auto;
    width: 490px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 8px 16px 0px #88C2EB;

    ::v-deep .el-input-group__append,
    .el-input-group__prepend {
      background-color: #2E77FE;
      color: #fff;
      border: none;
      padding: 0 20px;
      cursor: pointer;
    }

    ::v-deep .el-input__inner {
      border: none;
    }
  }
}

a {
  text-decoration: none;
}

ul li {
  list-style: none;
}

.container-fluid {
  min-width: 1200px;
  margin: 0 auto;
}

/* 版心 */
.container {
  width: 1200px;
  margin: 0 auto;
}

.banner-box {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-carousel {
    width: 100%;
    min-width: 1200px;

    img {
      min-width: 1200px;
      height: 400px;
    }
  }
}

.tec-box {
  .el-carousel {
    :nth-child(1) {
      margin-left: 20px;
    }

    :nth-child(2) {
      margin: 0 80px;
    }

    img {
      display: inline-block;
      width: 320px;
      height: 440px;
    }
  }
}

.comtitle {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 22px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
}

.allresitem {
  padding: 26px 40px;

  .title {
    display: flex;
    margin-top: 80px;
    justify-content: space-between;
    margin-bottom: 60px;

    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #000000;
    }

    .more {
      font-size: 18px;
      font-weight: 400;
      color: #7b7b7b;
    }
  }

  .resitem-box {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;

    .everitem {
      width: 240px;
      height: 407px;
      -border: 1px solid #ccc;

      .imgbox {
        width: 240px;
        height: 320px;
        margin-bottom: 12px;
        border: 1px solid #ccc;

        overflow: hidden;

        img {
          width: 240px;
        }
      }

      .content {
        .cont-title {
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }

        .name {
          font-size: 12px;
          font-weight: 400;
          color: #7b7b7b;
          margin: 4px 0 12px 0;
          display: block;
        }

        .num {
          font-size: 12px;
          font-weight: 400;
          color: #7b7b7b;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            color: #000;
          }

          .btn {
            width: 90px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            color: #fff;
            background: #5751fb;
          }
        }
      }
    }
  }
}

#ser {
  margin-top: 80px;

  .name {
    color: #313051;
    font-size: 30px;
    text-align: center;
    line-height: 50px;
  }

  ul {
    width: 100%;
    height: 280px;
    display: flex;
    justify-content: space-around;
  }

  li {
    transition: all 0.5s ease 0s;
    border-radius: 8px;
    overflow: hidden;
    width: 386px;

    text-align: center;
    padding: 40px 0;
    margin: 40px 0;
    cursor: pointer;
  }

  li:hover {
    box-shadow: 0 2px 20px 0 rgba(228, 228, 228, 0.5);
    border-color: #fff;
  }

  li div {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    margin: 0px 0 0px 0;
  }

  li p {
    font-size: 18px;
    margin-top: 8px;
  }

  li img {
    display: block;
    margin: 0px auto 20px auto;
  }
}

#data {
  height: 380px;
  background: url(~@/assets/image/data.png) center;
  margin-top: 40px;
  color: #fff;
  text-align: center;

  .u1 {
    padding-top: 70px;
    display: flex;
    justify-content: space-around;
  }

  .u1 li {
    .per {
      font-size: 52px;
    }

    .bd {
      width: 80px;
      height: 3px;
      background: #fff;
      margin: 20px auto;
    }

    .f18 {
      font-size: 18px;
    }
  }

  .u2 {
    width: 80%;
    margin: 40px auto 0 auto;
    display: flex;

    li {
      width: 33.33333%;

      .per {
        font-size: 28px;
      }

      .f18 {
        font-size: 16px;
      }
    }
  }
}

#prob {
  padding-top: 40px;
  background: #eee;

  .name {
    color: #313051;
    font-size: 30px;
    text-align: center;
  }

  #tab1 {
    width: 100%;
    margin-top: 40px;

    .tab_menu {
      height: 42px;
      border-bottom: 1px solid #ccc;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;

      .current {
        border-bottom: 2px solid #5e58fb;
      }

      li {
        display: flex;
        justify-content: center;
        height: 42px;
        font: 20px/42px "微软雅黑";
        color: #53526e;
        text-align: center;
        position: relative;
        cursor: pointer;
        padding: 0 20px;

        .bd {
          width: 160px;
          height: 2px;
          position: absolute;
          bottom: 0px;
          background: #5e58fb;
        }
      }
    }

    .tab_box {
      width: 740px;
      margin: 40px auto;

      .tab_box_item {
        color: #313051;
        font-size: 18px;
        display: none;
        line-height: 30px;
      }

      .hide {
        display: block;
      }

      p {
        color: #313051;
        font-size: 16px;
        margin-top: 10px;
      }

      .t {
        padding-left: 340px;
        height: 240px;
      }

      .t1 {
        background: url(~@/assets/image/t1.png) no-repeat;
        background-size: 300px 178px;
      }

      .t2 {
        background: url(~@/assets/image/t2.png) no-repeat;
        background-size: 300px 178px;
      }

      .t3 {
        background: url(~@/assets/image/t3.png) no-repeat;
        background-size: 300px 178px;
      }

      .t4 {
        background: url(~@/assets/image/t4.png) no-repeat;
        background-size: 300px 178px;
      }

      .t5 {
        background: url(~@/assets/image/t5.png) no-repeat;
        background-size: 300px 178px;
      }
    }
  }
}

#sol {
  .name {
    color: #313051;
    font-size: 30px;
    text-align: center;
  }

  .sol_box {
    display: flex;
    flex-wrap: wrap;

    li:hover {
      box-shadow: 0 2px 20px 0 rgba(228, 228, 228, 0.5);
      border-color: #fff;
    }

    li {
      transition: all 0.5s ease 0s;
      border-radius: 8px;
      overflow: hidden;
      width: 600px;

      text-align: center;
      margin: 40px 0;
      cursor: pointer;
      padding: 40px 100px;

      img {
        display: block;
        margin: 0 auto;
      }

      p {
        font-size: 20px;
        color: #313051;
        margin: 10px 0;
      }

      div {
        font: 15px/25px "微软雅黑";
        height: 75px;
      }

      a:hover {
        background-color: #5751fb;
        border-color: #5751fb;
        color: #fff;
        text-decoration: none;
        border-radius: 5px;
      }

      a {
        display: block;
        line-height: 38px;
        padding: 0 25px;
        border: 1px solid #5751fb;
        color: #5751fb;
        transition: all 0.5s ease 0s;
        font-size: 18px;
        border-radius: 5px;
        width: 170px;
        margin: 40px auto 0 auto;
      }
    }
  }
}

#coop {
  margin-top: 40px;

  .name {
    color: #313051;
    font-size: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      cursor: pointer;
      width: 18%;

      padding: 1%;

      img {
        transition: all 0.5s ease 0s;
        max-width: 100% !important;
        height: auto;
      }

      img:hover {
        box-shadow: 0 2px 20px 0 rgba(228, 228, 228, 0.6);
        border-color: #fff;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
